import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import ServerPicker from "@/pages/ServerPicker";
import Dashboard from "@/pages/Dashboard";
import Owner from "@/pages/Owner";
import Protection from "@/pages/Protection";
import Music from "@/pages/Music";
import SpotifyCallback from "@/pages/SpotifyCallback";
import AIFlags from "@/pages/AIFlags";
import TermsOfService from "@/pages/TermsOfService";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import VerifyStart from "@/pages/VerifyStart";
import VerifyCallback from "@/pages/VerifyCallback";
import GlobalFooter from "@/components/GlobalFooter";
import Stats from "@/pages/Stats";
import { isAuthed } from "@/lib/apiClient";

function Protected({ children }) {
  if (!isAuthed()) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0D0E15",
            border: "1px solid rgba(139,92,246,0.35)",
            borderRadius: 12,
            color: "#FFFFFF",
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "12px",
          },
        }}
      />
      <div className="flex flex-col min-h-screen">
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/tos" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/stats" element={<Stats />} />
            <Route path="/verify/callback" element={<VerifyCallback />} />
            <Route path="/verify/:guildId" element={<VerifyStart />} />
            <Route path="/servers" element={<Protected><ServerPicker /></Protected>} />
            <Route path="/dashboard/:guildId" element={<Protected><Dashboard /></Protected>} />
            <Route path="/owner" element={<Protected><Owner /></Protected>} />
            <Route path="/protection/:guildId" element={<Protected><Protection /></Protected>} />
            <Route path="/music/:guildId" element={<Protected><Music /></Protected>} />
            <Route path="/auth/spotify/callback" element={<Protected><SpotifyCallback /></Protected>} />
            <Route path="/ai-flags/:guildId" element={<Protected><AIFlags /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <GlobalFooter />
      </div>
    </BrowserRouter>
  );
}
